<template>
  <div class="center-cmp box box_v">
    <dv-border-box-9>

<!--      <div class="cc-header">-->
<!--        <dv-decoration-1 class="xian"/>-->
<!--        用券消费总额-->
<!--        <dv-decoration-1 class="xianright"/>-->
<!--      </div>-->

      <div class="cc-details box">

        <div style="font-size: 50px">￥</div>
        <div class="carddiv"
             v-for="num in getCardNum(goodsAmountCount)">
          <div v-if="num!=','" class="card">{{num}}</div>
          <div v-else>,</div>
        </div>
      </div>

      <div class="cc-bottom box box_center">
        <table>
          <tr>
            <td><div class="title">超市券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(supermarket.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(supermarket.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(supermarket.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(supermarket.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">百货券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(market.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(market.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(market.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(market.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">家电券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(device.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(device.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(device.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(device.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">金银珠宝券：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(jewelryt.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(jewelryt.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(jewelryt.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(jewelryt.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">汽车1类：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car1.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car1.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car1.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car1.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">汽车2类：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car2.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car2.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car2.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car2.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">汽车3类：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car3.receiveNum, true)}}</div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car3.unConsumeNum, true)}}</div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car3.consumeNum, true)}}</div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;{{toThousands(car3.allowanceAmount, true)}}</div></td>
          </tr>
          <tr>
            <td><div class="title">合计：</div></td>
            <td><div class="title-ff">领取</div></td>
            <td><div class="title-num">&nbsp;
              {{toThousands(supermarket.receiveNum + market.receiveNum + device.receiveNum + jewelryt.receiveNum + car1.receiveNum + car2.receiveNum + car3.receiveNum, true)}}
            </div></td>
            <td><div class="title-ff">未核销</div></td>
            <td><div class="title-num">&nbsp;
              {{toThousands(supermarket.unConsumeNum + market.unConsumeNum + device.unConsumeNum + jewelryt.unConsumeNum + car1.unConsumeNum + car2.unConsumeNum + car3.unConsumeNum, true)}}
            </div></td>
            <td><div class="title-ff">核销</div></td>
            <td><div class="title-num">&nbsp;
              {{toThousands(supermarket.consumeNum + market.consumeNum + device.consumeNum + jewelryt.consumeNum + car1.consumeNum + car2.consumeNum + car3.consumeNum, true)}}
            </div></td>
            <td><div class="title-ff">补贴金额</div></td>
            <td><div class="title-num">&nbsp;
              {{toThousands(supermarket.allowanceAmount + market.allowanceAmount + device.allowanceAmount + jewelryt.allowanceAmount+ car1.allowanceAmount + car2.allowanceAmount + car3.allowanceAmount, true)}}
            </div></td>
          </tr>

        </table>
      </div>
    </dv-border-box-9>


  </div>
</template>

<script>
  export default {
      name: "centerCmp",
      computed: {
        xiaofeiquanVue() {
          return this.$store.state.xiaofeiquanVue
        },
      },
      created() {
        this.load()
      },
      data() {
        return {
          "supermarket": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "market": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "goodsAmountCount": 0,
          "device": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "jewelryt": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "car1": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "car2": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          },
          "car3": {
            "allowanceAmount": 0,
            "receiveNum": 0,
            "consumeNum": 0,
            "unConsumeNum": 0
          }
        }
      },
      methods: {
        load() {
          this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/consume/count', {},res=> {
            if(res.newPrimaryKeys) {
              if(res.newPrimaryKeys.supermarket) {
                this.supermarket = res.newPrimaryKeys.supermarket
              }
              if(res.newPrimaryKeys.market) {
                this.market = res.newPrimaryKeys.market
              }
              if(res.newPrimaryKeys.goodsAmountCount) {
                this.goodsAmountCount = res.newPrimaryKeys.goodsAmountCount
              }
              if(res.newPrimaryKeys.device) {
                this.device = res.newPrimaryKeys.device
              }
              if(res.newPrimaryKeys.jewelryt) {
                this.jewelryt = res.newPrimaryKeys.jewelryt
              }
              if(res.newPrimaryKeys.car1) {
                this.car1 = res.newPrimaryKeys.car1
              }
              if(res.newPrimaryKeys.car2) {
                this.car2 = res.newPrimaryKeys.car2
              }
              if(res.newPrimaryKeys.car3) {
                this.car3 = res.newPrimaryKeys.car3
              }
            }
          })
        },
        setData() {

        },
        getCardNum(num) {
          return this.toThousands(num)
        },
        toThousands(_num, bol) {
          _num = _num.toFixed(4)*1
          let numArr = (_num+'').split('.')
          let num = parseInt(numArr[0])
          let xs = numArr[1]?numArr[1]:''

          let result = [ ], counter = 0;
          num = (num || 0).toString().split('')
          for (let i = num.length - 1; i >= 0; i--) {
            counter++
            result.unshift(num[i])
            if (!(counter % 3) && i != 0) { result.unshift(','); }
          }
          if(xs) {
            result = [...result, '.', ...xs.split('')]
          }
          if(bol) {
            return result.join('')
          }else {
            return result
          }
        }
      },
  }
</script>

<style lang="less">
  .center-cmp {
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;

    .cc-header {
      height: 30px;
      text-align: center;
      font-size: 20px;
      position: relative;

      .xian {
        width: 150px;
        height: 30px;
        top: 0;
        left: 20px;
        position: absolute;
      }
      .xianright {
        width: 150px;
        height: 30px;
        top: 0;
        right: 0px;
        position: absolute;
      }
    }
    .cc-details {
      height: 60px;
      justify-content: center;
      font-size: 28px;
      align-items: center;
      .carddiv {

        .card {
          background-color: rgba(4,49,128,.6);
          color: #08e5ff;
          height: 60px;
          width: 45px;
          font-size: 55px;
          font-weight: bold;
          line-height: 60px;
          text-align: center;
          margin: 5px;
        }
      }

    }

    .cc-bottom {
      height: 160px;
      font-size: 14px;
      box-sizing: border-box;

      .title {
        color: rgb(85, 198, 255);
        padding-right: 10px;
      }
      .title-ff {
        font-size: 12px;
      }
      .title-num {
        color: rgb(255, 252, 134);
        padding-right: 10px;
        font-size: 12px;
      }
    }
  }
</style>
